import {Injectable} from "@angular/core";

import {HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs/Observable";

import * as cache from "memory-cache";

@Injectable()
export class CachingInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if(req.url.includes("app/config/nav-config.json")) {
      req = req.clone({
        params: new HttpParams().set("version", "v9")
      });
    }
    if(req.url.includes("app/config/core-nav-config.json")) {
      req = req.clone({
        params: new HttpParams().set("version", "v3")
      });
    }
    if(req.url.includes("icons/core.svg")) {
      req = req.clone({
        params: new HttpParams().set("version", "v5")
      });
    }
    if(req.url.includes("icons/prime.svg")) {
      req = req.clone({
        params: new HttpParams().set("version", "v4")
      });
    }
    if(req.url.includes("app/config/header-config.json")) {
      req = req.clone({
        params: new HttpParams().set("version", "v4")
      });
    }
    if (req.method === "GET" && CachingInterceptor.isCacheRequest(req.urlWithParams)) {
      return CachingInterceptor.sendRequest(req, next);
    }
    return next.handle(req);
  }

  private static sendRequest(req: HttpRequest<any>,
                             next: HttpHandler): Observable<HttpEvent<any>> {
    if (!cache.get(req.urlWithParams)) {
      cache.put(req.urlWithParams, next.handle(req).shareReplay(1), 10000); // Update the cache.
    }
    return cache.get(req.urlWithParams);
  }

  private static removeFromCache(keyToRemove: RegExp) {
    cache.keys().filter((key) => keyToRemove.test(key))
                .forEach((key) => cache.del(key));
  }

  private static isCacheRequest(url: string) {
    return url.includes("/formmanagementservice")
      || url.includes("/kbservice")
      || url.includes("/validationservice")
      || url.includes("/mlservice")
      || url.includes("/datasetservice");
  }
}
